"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumRecordStackupType = exports.AltiumRecordRULType = exports.AltiumRecordDefinitions = void 0;
exports.parseAltiumRecordFile = parseAltiumRecordFile;
function parseAltiumRecord(record, allowUntyped) {
    if (record.startsWith('|')) {
        record = record.substring(1);
    }
    if (record.endsWith('|')) {
        record = record.substring(0, record.length - 1);
    }
    const parts = record.split('|');
    if (parts.length < 2) {
        return null;
    }
    const result = {};
    for (const part of parts) {
        if (!part.length) {
            continue;
        }
        if (!part.includes('=')) {
            continue;
        }
        const key = part.substring(0, part.indexOf('=')).toUpperCase();
        const value = part.substring(part.indexOf('=') + 1);
        if (!value || value.length === 0) {
            continue;
        }
        if (key === 'RECORD') {
            const definition = exports.AltiumRecordDefinitions[value];
            if (!definition) {
                return null;
            }
            result.RECORD = value;
        }
        else {
            result[key] = value;
        }
    }
    if (!allowUntyped && !result.RECORD) {
        return null;
    }
    return result;
}
function parseAltiumRecordFile(contents, supportedDefinitions = exports.AltiumRecordDefinitions, allowUnknown, implicitRecordType) {
    const records = [];
    const lines = contents.split('\n');
    for (let line of lines) {
        line = line.trim();
        if (line.length === 0) {
            continue;
        }
        const record = parseAltiumRecord(line, !!implicitRecordType);
        if (!record) {
            continue;
        }
        if (!record.RECORD && implicitRecordType) {
            record.RECORD = implicitRecordType.name;
        }
        const definition = supportedDefinitions[record.RECORD] ?? implicitRecordType;
        if (!definition) {
            if (allowUnknown) {
                records.push(record);
            }
            continue;
        }
        for (const property of definition.properties) {
            if (property.required && record[property.name] === undefined) {
                throw new Error(`Property ${property.name} is required for record ${record.RECORD}`);
            }
            if (record[property.name] === undefined) {
                continue;
            }
            if (property.type === 'number') {
                try {
                    record[property.name] = parseFloat(record[property.name]);
                }
                catch {
                    throw new Error(`Property ${property.name} is not a number for record ${record.RECORD}`);
                }
            }
            if (property.type === 'boolean') {
                record[property.name] = record[property.name].toLowerCase().trim() === 'true';
            }
            if (typeof record[property.name] !== property.type) {
                throw new Error(`Property ${property.name} is required for record ${record.RECORD}`);
            }
        }
        records.push(record);
    }
    return records;
}
exports.AltiumRecordDefinitions = {
    BOM: {
        name: 'BOM',
        properties: [
            { name: 'VERSION', type: 'string' },
            { name: 'FILENAME', type: 'string' },
            { name: 'KIND', type: 'string' },
            { name: 'DATE', type: 'string' },
            { name: 'TIME', type: 'string' },
            { name: 'CURRENCY', type: 'string' },
            { name: 'PRODUCTIONQUANTITY', type: 'number' },
            { name: 'PERUNITTARGETPRICE', type: 'number' },
            { name: 'PERUNITACTUALPRICE', type: 'number' },
        ],
    },
    GeneralOptions: {
        name: 'GeneralOptions',
        properties: [
            { name: 'OPENEXPORTED', type: 'boolean' },
            { name: 'ADDTOPROJECT', type: 'boolean' },
            { name: 'FORCEFIT', type: 'boolean' },
            { name: 'NOTFITTED', type: 'boolean' },
            { name: 'TEMPLATEFILENAME', type: 'string' },
            { name: 'BATCHMODE', type: 'number' },
            { name: 'SUPPLIERPRODQTY', type: 'number' },
            { name: 'SUPPLIERAUTOQTY', type: 'boolean' },
            { name: 'SUPPLIERUSECACHEDPRICING', type: 'boolean' },
            { name: 'SUPPLIERCURRENCY', type: 'string' },
            { name: 'SOLUTIONSPERITEM', type: 'number' },
            { name: 'SUPPLIERSPERSOLUTION', type: 'number' },
            { name: 'DISPLAYTOTALROW', type: 'boolean' },
            { name: 'DISPLAYSUBTOTALSFORGROUPS', type: 'boolean' },
            { name: 'INCLUDEPCBPARAMETERS', type: 'boolean' },
            { name: 'INCLUDEDBPARAMETERS', type: 'boolean' },
            { name: 'INCLUDEVAULTPARAMETERS', type: 'boolean' },
            { name: 'INCLUDECLOUDPARAMETERS', type: 'boolean' },
            { name: 'INCLUDEDOCUMENTPARAMETERS', type: 'boolean' },
            { name: 'FILTEROUTRISKYSOLUTIONS', type: 'boolean' },
            { name: 'DESIGNATORGROUPING', type: 'string' },
        ],
    },
    SortOrderOptions: {
        name: 'SortOrderOptions',
        properties: [{ name: 'SORTORDER', type: 'string' }],
    },
    GroupOrderOptions: {
        name: 'GroupOrderOptions',
        properties: [{ name: 'GROUPORDER', type: 'string' }],
    },
    VisibleOrderOptions: {
        name: 'VisibleOrderOptions',
        properties: [{ name: 'VISIBLEORDER', type: 'string' }],
    },
    VisibleOrderOptions2: {
        name: 'VisibleOrderOptions2',
        properties: [
            { name: 'BASEVIEW', type: 'string' },
            { name: 'FLATVIEW', type: 'string' },
            { name: 'CONSOLIDATEDVIEW', type: 'string' },
        ],
    },
    CustomColumns: {
        name: 'CustomColumns',
        properties: [{ name: 'CUSTOMCOLUMNS', type: 'string' }],
    },
    ColumnsAliases: {
        name: 'ColumnsAliases',
        properties: [{ name: 'COLUMNSALIASES', type: 'string' }],
    },
    FilterOptions: {
        name: 'FilterOptions',
        properties: [{ name: 'FILTER', type: 'string' }],
    },
    CheckGroupCompParamsOptions: {
        name: 'CheckGroupCompParamsOptions',
        properties: [{ name: 'CHECKGROUPCOMPPARAMS', type: 'string' }],
    },
    ManufacturerLinkOptions: {
        name: 'ManufacturerLinkOptions',
        properties: [{ name: 'MANUFACTURERLINKPARAMETERS', type: 'string' }],
    },
    FavoriteSuppliers: {
        name: 'FavoriteSuppliers',
        properties: [
            { name: 'SUPPLIERS', type: 'string' },
            { name: 'USESUPPLIERORDER', type: 'boolean' },
        ],
    },
    CheckOptions: {
        name: 'CheckOptions',
        properties: [{ name: 'CHECKLEVELS', type: 'string' }],
    },
    LineNumberingOptions: {
        name: 'LineNumberingOptions',
        properties: [
            { name: 'STARTVALUE', type: 'string' },
            { name: 'INCREMENT', type: 'string' },
        ],
    },
    Catalog: {
        name: 'Catalog',
        properties: [{ name: 'DBLINKFILEPATH', type: 'string' }],
    },
    CatalogItem: {
        name: 'CatalogItem',
        properties: [
            { name: 'ITEMTYPE', type: 'string' },
            { name: 'UNIQUEID', type: 'string' },
            { name: 'DESIGNITEMID', type: 'string' },
            { name: 'ITEMSOURCE', type: 'string' },
            { name: 'STATUS', type: 'string' },
            { name: 'DESCRIPTION', type: 'string' },
            { name: 'USERCOMMENTS', type: 'string' },
            { name: 'NOTE', type: 'string' },
            { name: 'LINENUMBER', type: 'string' },
            { name: 'SELECTEDPARAMETERSHASH', type: 'string' },
            { name: 'COMPONENTPARAMETERS', type: 'string' },
        ],
    },
    TopLevelDocument: {
        name: 'TopLevelDocument',
        properties: [
            { name: 'FILENAME', type: 'string', required: true },
            { name: 'SHEETNUMBER', type: 'number' },
        ],
    },
    NoMainPathDocument: {
        name: 'NoMainPathDocument',
        properties: [
            { name: 'SOURCEDOCUMENT', type: 'string' },
            { name: 'FILENAME', type: 'string', required: true },
            { name: 'SHEETNUMBER', type: 'number' },
        ],
    },
    SheetSymbol: {
        name: 'SheetSymbol',
        properties: [
            { name: 'FILENAME', type: 'string', required: true },
            { name: 'SOURCEDOCUMENT', type: 'string' },
            { name: 'DESIGNATOR', type: 'string' },
            { name: 'SCHDESIGNATOR', type: 'string' },
            { name: 'SHEETNUMBER', type: 'string' },
            { name: 'SYMBOLTYPE', type: 'string' },
            { name: 'RAWFILENAME', type: 'string' },
            { name: 'DESIGNITEMID', type: 'string' },
            { name: 'SOURCELIBRARYNAME', type: 'string' },
            { name: 'OBJECTKIND', type: 'string' },
            { name: 'REVISIONGUID', type: 'string' },
            { name: 'ITEMGUID', type: 'string' },
            { name: 'VAULTGUID', type: 'string' },
        ],
    },
};
exports.AltiumRecordRULType = {
    name: 'RUL',
    properties: [
        { name: 'SELECTION', type: 'boolean' },
        { name: 'LAYER', type: 'string' },
        { name: 'LOCKED', type: 'boolean' },
        { name: 'POLYGONOUTLINE', type: 'boolean' },
        { name: 'USERROUTED', type: 'boolean' },
        { name: 'KEEPOUT', type: 'boolean' },
        { name: 'UNIONINDEX', type: 'number' },
        { name: 'RULEKIND', type: 'string' },
        { name: 'NETSCOPE', type: 'string' },
        { name: 'LAYERKIND', type: 'string' },
        { name: 'SCOPE1EXPRESSION', type: 'string' },
        { name: 'SCOPE2EXPRESSION', type: 'string' },
        { name: 'NAME', type: 'string' },
        { name: 'ENABLED', type: 'boolean' },
        { name: 'PRIORITY', type: 'number' },
        { name: 'COMMENT', type: 'string' },
        { name: 'UNIQUEID', type: 'string' },
        { name: 'DEFINEDBYLOGICALDOCUMENT', type: 'boolean' },
        { name: 'BGADIR', type: 'string' },
        { name: 'BGAVIAMODE', type: 'string' },
        { name: 'FANOUTSTYLE', type: 'string' },
        { name: 'FANOUTDIRECTION', type: 'string' },
        { name: 'VIAGRID', type: 'string' },
    ],
};
exports.AltiumRecordStackupType = {
    name: 'STACKUP',
    properties: [
        { name: 'STACKUPVERSION', type: 'number', required: true },
        { name: 'STACKUPDOCUMENTID', type: 'string' },
        { name: 'STACKUPDOCUMENTREVISIONID', type: 'string' },
    ],
};
//# sourceMappingURL=altiumRecordFile.js.map